export default __webpack_public_path__ + "7aaf5b74a50cc2224edc821ee5429467.png";